import * as angular from "angular";
import {IController} from "angular";

export class FulfillmentStepSelectItemComponent implements IController {
  step: any;
  selectedStepId: string;
}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentStepSelectItem', {
    require: {
      form: '^form'
    },
    bindings: {
      step: '<',
      selectedStepId: '<'
    },
    template: require('./fulfillment-step-select-item.html').default,
    controller: FulfillmentStepSelectItemComponent
  });
